
import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faBoxOpen, faChartPie, faCog, faFileAlt, faHandHoldingUsd, faSignOutAlt, faTable, faTimes, faCalendarAlt, faMapPin, faInbox, faRocket } from "@fortawesome/free-solid-svg-icons";
import { Nav, Badge, Image, Button, Dropdown, Accordion, Navbar } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import ThemesbergLogo from "../assets/img/themesberg.svg";
import ReactHero from "../assets/img/technologies/react-hero-logo.svg";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";
import PRIVATE_ROUTES from "../routes/PrivateRoutes";

export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
            <span>
              <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = (props) => {
    const { title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary" } = props;
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-between" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
            {image ? <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" /> : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} >
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button as={Link} variant="secondary" size="xs" className="text-dark">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              <NavItem title="Dashboard" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.DASHBOARD.path} />
              <NavItem title="Clientes" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.CLIENTS.path} />
              <NavItem title="Empleados" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.EMPLOYEES.path} />
              <NavItem title="Categorias" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.CATEGORIES.path} />
              <NavItem title="Imagenes de servicio" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.SERVICE_IMAGES.path} />
              <NavItem title="Servicios" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.SERVICES.path} />
              <NavItem title="Productos" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.PRODUCTS.path} />
              <NavItem title="Ordenes Confirmadas" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.ORDERS.path} />
              <NavItem title="Ordenes Canceladas" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.CANCEL.path} />
              <NavItem title="Ordenes En Busqueda" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.SEARCH.path} />
              <NavItem title="Descuentos" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.DISCOUNTS.path} />
              <NavItem title="Devoluciones" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.REFUNDS.path} />
              <NavItem title="Evaluaciones" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.RATING_BADGES.path} />
              <NavItem title="Cuentas" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.ACCOUNTS.path} />
              <NavItem title="Precios por distancia" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.DISTANCE_PRICE.path} />
              <NavItem title="Porcentajes de ganancia" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.PROFITS_PERCENTAGE.path} />
              <NavItem title="Comentarios" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.COMENTS.path} />
              {/*<NavItem title="Lavanderias" icon={faHandHoldingUsd} link={PRIVATE_ROUTES.LAUNDRY.path} />*/}
              {/*<NavItem external title="Plugins" link="https://demo.themesberg.com/volt-pro-react/#/plugins/datatable" target="_blank" badgeText="Pro" icon={faChartPie} />*/}
              {/*<Dropdown.Divider className="my-3 border-indigo" />*/}
              {/*<CollapsableNavItem eventKey="documentation/" title="Getting Started" icon={faBook}>*/}
              {/*  <NavItem title="Overview" link={Routes.DocsOverview.path} />*/}
              {/*  <NavItem title="Download" link={Routes.DocsDownload.path} />*/}
              {/*  <NavItem title="Quick Start" link={Routes.DocsQuickStart.path} />*/}
              {/*  <NavItem title="License" link={Routes.DocsLicense.path} />*/}
              {/*  <NavItem title="Folder Structure" link={Routes.DocsFolderStructure.path} />*/}
              {/*  <NavItem title="Build Tools" link={Routes.DocsBuild.path} />*/}
              {/*  <NavItem title="Changelog" link={Routes.DocsChangelog.path} />*/}
              {/*</CollapsableNavItem>*/}
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
